<spinner-button class="me-3" [refreshState$]="isProcessing$" label="{{ 'ml_143927' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}" (click)="fileImport.click()">
</spinner-button>
<input #fileImport [accept]="'.xlsx,.xlsm'" type="file" class="file-input" (change)="onImport($event)" hidden="true" />
